/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'coding-info': {
    width: 200,
    height: 200,
    viewBox: '0 0 1024 1024',
    data: '<defs/><path pid="0" d="M0 0v837.973h1024V0zm930.702 744.676H93.298V93.298h837.404zM46.65 930.702H977.35V1024H46.65z"/><path pid="1" d="M467.627 334.507h86.47v323.129h-86.47zm-126.294-60.871L150.756 464.213 341.333 655.36l58.596-58.596-131.982-132.55L399.929 332.23l-58.596-58.595zm341.334 0L624.07 332.23l131.982 131.982-131.982 132.551 58.596 58.596 190.577-191.147-190.577-190.577zm-217.885-57.458h94.436v89.315h-94.436z"/>'
  }
})
